import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/surveyscripting/crossplatform.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/surveyscripting/dataquality.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/surveyscripting/scripting.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/surveyscripting/survey.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/DataCollectionMobileCarousel/index.tsx");
